
<script setup>

  import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import AudioPlayer from '../components/audio-player.vue';

  import audio_s1e1_1945_2240 from '../audio/s1e1_1945_2240.mp3';

  import track_s1e1_1945_2240 from '../audio/s1e1_1945_2240.vtt';

  import backgroundPath from '../images/map-background.jpg';

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center" :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="p-6">

        <div class="max-w-md">

          <h2 class="pb-6 border-b-[3px] border-black">

            <div class="text-xl tracking-narrow font-semibold uppercase">Activity 2</div>

            <div class="text-4xl md:text-5xl font-heading uppercase">Completed!</div>

          </h2>

          <p class="mt-8 leading-7 text-neutral-700">

            You have completed Activity 2: Jim Crow Era Traveling.

            You can continue to Activity 3: The Essence of Life at Lewis, or you can return Home to choose another activity.

          </p>

          <div class="mt-12">

            <AudioPlayer :src="audio_s1e1_1945_2240" :track="track_s1e1_1945_2240" />
          
            <div class="mt-3 text-xs italic">Source: Driving the Green Book - Macmillan Podcasts - S1:E1</div>

          </div>

          <blockquote class="mt-12 pl-6 border-l-4 border-black">

            <p>

              <span class="text-xl">"</span>
              
              There will be a day sometime in the near future when this guide will not have to be published.
              
              That is when we as a race will have equal opportunities and privileges in the United States.
              
              It will be a great day for us to suspend this publication for then we can go wherever we please, and without embarrassment.
              
              <span class="text-xl">"</span>

            </p>

            <cite class="block mt-4">&mdash; Victor H. Green, author of The Green Book</cite>

          </blockquote>

          <div class="flex flex-wrap justify-between gap-6 mt-12">

            <RouterLink

              class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                
                hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"
            
              to="/activities">
              
              <ArrowLeftCircleIcon class="w-8" />

              <span>Home</span>
            
            </RouterLink>

            <RouterLink

              class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
              
                hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
            
              to="/activity/3">
              
              <span>Next Activity</span>

              <ArrowRightCircleIcon class="w-8" />
            
            </RouterLink>

          </div>

        </div>

      </div>

    </div>

  </article>

</template>
